<template>
  <section class="min-h-screen bg-gray-100 pt-16 pb-8 px-4">
    <div class="max-w-7xl mx-auto space-y-10">
      <!-- Heading -->
      <div class="text-center mb-12">
        <h2 class="text-4xl md:text-5xl font-extrabold tracking-tight text-primary mb-4 leading-tight drop-shadow-lg">
          How TrendzTube Works
        </h2>
        <p class="mt-4 text-base md:text-lg text-gray-700">
          Get viral YouTube video ideas in just 3 simple steps
        </p>
      </div>

      <!-- Steps -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <!-- Step 1 -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col">
          <div class="mock-wrap">
            <div class="mock-surface overflow-hidden h-40 md:h-48 flex items-stretch justify-stretch">
              <img src="@/assets/screenshot_1.png" alt="Step 1" class="w-full h-full object-cover rounded-lg" />
            </div>
          </div>
          <div class="mt-6">
            <span class="step-pill">STEP 1</span>
            <h3 class="mt-3 text-lg font-semibold text-primary-dark">Select Your Niche</h3>
            <p class="mt-2 text-sm text-gray-600">
              Choose your target region and category to analyze the most relevant trending content for your audience.
            </p>
          </div>
        </div>

        <!-- Step 2 -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col">
          <div class="mock-wrap">
            <div class="mock-surface overflow-hidden h-40 md:h-48 flex items-stretch justify-stretch">
              <img src="@/assets/screenshot_2.png" alt="Step 2" class="w-full h-full object-cover rounded-lg" />
            </div>
          </div>
          <div class="mt-6">
            <span class="step-pill">STEP 2</span>
            <h3 class="mt-3 text-lg font-semibold text-primary-dark">Analyze Trends</h3>
            <p class="mt-2 text-sm text-gray-600">
              Our AI scans hundreds of trending videos, identifies patterns, and extracts key insights from successful content.
            </p>
          </div>
        </div>

        <!-- Step 3 -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col">
          <div class="mock-wrap">
            <div class="mock-surface overflow-hidden h-40 md:h-48 flex items-stretch justify-stretch">
              <img src="@/assets/screenshot_3.png" alt="Step 3" class="w-full h-full object-cover rounded-lg" />
            </div>
          </div>
          <div class="mt-6">
            <span class="step-pill">STEP 3</span>
            <h3 class="mt-3 text-lg font-semibold text-primary-dark">Get Video Ideas</h3>
            <p class="mt-2 text-sm text-gray-600">
              Instantly receive tailored video ideas with titles, descriptions, and insights on why they could go viral.
              <br />
              Each idea also shows the trending YouTube videos that inspired it, so you can view thumbnails, watch the source videos, or copy their links for further research.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HowItWorks"
};
</script>

<style scoped>
.mock-wrap {
  border-radius: 0.75rem;
  padding: 0.75rem;
  background: linear-gradient(180deg, rgba(239,68,68,0.10), rgba(239,68,68,0.04));
}
.mock-surface {
  position: relative;
  border-radius: 0.75rem;
  background: #fff;
  min-height: 10rem;
  box-shadow: 0 2px 8px 0 rgba(239,68,68,0.06);
}
.mock-surface::before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 2px;
  border-radius: inherit;
  background: linear-gradient(145deg, rgba(239,68,68,0.18), rgba(239,68,68,0.08));
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
          mask-composite: exclude;
  pointer-events: none;
}
.step-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  margin-bottom: 0.5rem;
  background: rgba(239,68,68,0.10);
  color: #dc2626;
}
/* Match VideoRecommendations.vue shadows and styling */
.shadow-sm {
  box-shadow: 0 2px 8px 0 rgba(80,36,255,0.06);
}
.rounded-lg {
  border-radius: 0.75rem;
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
</style>
